import {
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  makeStyles,
  mergeClasses,
} from "@fluentui/react-components";
import { ChevronUpDownRegular, GlobeRegular } from "@fluentui/react-icons";
import React, { useState } from "react";

import { useTranslationLang } from "@/i18n";

import { LanguageSelectMenuItems } from "../LanguageSelectMenuItems";
import { LANGUAGE_SELECT_ENDONYMS, LANGUAGE_SELECT_LABEL } from "../constants";
import { useLanguageSelectMenuCheckedProps } from "../useLanguageSelectMenuCheckedProps";

const ICON_COLOR = "var(--figma-color-lightBlack)";
const SUBMENU_HOVER_DELAY_MS = 100;

const useStyles = makeStyles({
  trigger: {
    alignItems: "center",
    whiteSpace: "nowrap",
  },
});

/** アカウントメニュー内の言語切り替え。選択してもアカウントメニューは開いたままにする。 */
export const LanguageSelectAccountMenuSubmenu: React.FC<{
  className?: string;
}> = ({ className }) => {
  const styles = useStyles();
  const { lang } = useTranslationLang();
  const { checkedValues, onCheckedValueChange } =
    useLanguageSelectMenuCheckedProps();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Menu
      checkedValues={checkedValues}
      onCheckedValueChange={(event, data) => {
        onCheckedValueChange(event, data);
        setIsOpen(false);
      }}
      persistOnItemClick
      open={isOpen}
      onOpenChange={(_event, data) => setIsOpen(data.open)}
      hoverDelay={SUBMENU_HOVER_DELAY_MS}
    >
      <MenuTrigger disableButtonEnhancement>
        <MenuItem
          className={mergeClasses(styles.trigger, className)}
          icon={<GlobeRegular color={ICON_COLOR} />}
          secondaryContent={LANGUAGE_SELECT_ENDONYMS[lang]}
          submenuIndicator={<ChevronUpDownRegular />}
        >
          {LANGUAGE_SELECT_LABEL}
        </MenuItem>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          <LanguageSelectMenuItems />
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
